<template>

    <div>
        <div class="xinz">
		<!-- <div style="color: red;" @click="clickprinting()">打印報表</div> -->
            <template v-if="EDIT_LOCATION">
                <div class="right">
                    <el-button type="warning" @click="locationAdd" v-if="$store.getters.sta" ><i class="fa fa-plus" /> 新增</el-button>
                </div>
            </template>
        </div>
        <div v-if="loadingimg" style="position: absolute;left: 50%;top: 34%;"><img src="../assets/loding.gif" /></div>

        <div v-if="loading">
            <div class="ind_main">
                <div class="ind_cont">

                    <div class="tabs" v-if="$store.getters.ismobilePhone == false">
                        <div class="tab-item" v-for="flo in locationList" v-bind:class="{'active':flo.floor == num}" :id="'tab'+flo.floor">
                            <div class="ind_txt">
                                <div class="fl">
									當前<span style="color: #285EFF;">{{presentnum}}/F</span><span style="color: #333333;">樓層共{{flo.floorcount}}個位置，剩餘{{flo.floorcount-flo.usecount}}個 </span>
                                    <span style="color: #FF394D">( {{useflocountSum}}/{{floorcountSum}} ) 空置率：{{((floorcountSum - useflocountSum)/floorcountSum*100).toFixed(2)}}%</span>
                                </div>
                                <div class="fr">
									<div class="kx"><span>空閒 </span></div>
									<div class="wl"><span>物料 </span></div>
									<div class="yd"><span>一單</span>  <img src="../../static/img/redHomeIcon.png"></img></div>
									<div class="ed"><span>多單</span>  <img src="../../static/img/blueHomeIcon.png"></img></div>
								<!-- <span class="kx"><span>空闲</span></span>
								<span>一單</span>
								<span>双單</span> -->
								<!-- 總樓層共<span class="bule">{{flo.loccount}}</span>個，總樓層共使用<span class="bule">{{flo.useflocount}}</span>個 -->
								
								
								</div>
                            </div>

								
                            <div class="tab_box">

                                <!-- &lt;!&ndash; 左邊4個 &ndash;&gt; -->
                                <table cellpadding="0" cellspacing="0" class="tab1">
                                    <tr v-for="n in 4"  class="xuline" style="width:24%; float:left;">
                                        <template v-for="y in flo.maxY"  class="xuline" style="width:25%; float:left;">
                                            <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta)">
                                                <td v-bind:class="{'cur':flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).state == 1&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0}"
                                                    @click="locationEdit(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).id)">
                                                   <span>
													{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).name}}
													</span>
													 <img src="../../static/img/redHomeIcon.png"></img>
													</td>
                                            </template>
                                            <template v-else-if="$store.getters.sta" class="cur">
                                                <td> </td>
                                            </template>
                                            <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false)">
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).isCount <=1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0 ">
                                                    <td class="cur" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
	<!-- 一单 -->
														<span>{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}</span>
														 <img src="../../static/img/redHomeIcon.png"></img>
														</td>
                                                </template>
												<!-- 二单 -->
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).isCount > 1&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0 ">
                                                    <td class="curTwo" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                        <span>
														{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
														</span>
														 <img src="../../static/img/blueHomeIcon.png"></img>
														</td>
                                                </template>
												<!-- 空闲-->
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 0 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="curThree" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                       <span>
													  {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													  </span>
													  </td>
                                                </template>
												<!-- 物料 -->
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==1">
												    <td class="curFive" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
												       <span>
													  {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													  </span>
													  </td>
												</template>
                                            </template>
                                            <template v-else-if="$store.getters.sta==false">
                                                <td class="curfour"></td>
                                            </template>
                                        </template>
                                    </tr>
                                </table>

                                <!--  &lt;!&ndash; 中間八個 &ndash;&gt; -->
                                <table cellpadding="0" cellspacing="0" class="tab2">
                                    <tr v-for="n in 10" v-if="n>4" class="xuline" style="width:16%; float:left;">
                                        <template v-for="y in flo.maxY"  class="xuline" style="width:25%; float:left;">
                                            <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta)">
                                                <td v-bind:class="{'cur':flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0}"
                                                    @click="locationEdit(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).id)">
                                                    <span>
													{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).name}}
													</span>
													 <img src="../../static/img/redHomeIcon.png"></img>
													</td>
                                            </template>
                                            <template v-else-if="$store.getters.sta">
                                                <td   class="curfour"></td>
                                            </template>
                                            <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false)">
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 && flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).isCount <= 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="cur" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                       <span>
													   {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													   </span>
													    <img src="../../static/img/redHomeIcon.png"></img>
													   </td>
                                               
												</template>
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 && flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).isCount > 1&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="curTwo" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                       <span>
													   {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													    </span>
														<img src="../../static/img/blueHomeIcon.png"></img>
													   </td>
                                                </template>
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 0&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="curThree" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                        <span>
														{{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
														</span>
														</td>
                                                </template>
												<!-- 物料 -->
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==1">
												    <td class="curFive" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
												       <span>
													  {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													  </span>
													  </td>
												</template>
                                            </template>
                                            <template v-else-if="$store.getters.sta==false">
                                                <td class="curfour"></td>
                                            </template>
                                        </template>
                                    </tr>
                                </table>

                               <!-- &lt;!&ndash; 右邊4個 &ndash;&gt; -->
                                <table cellpadding="0" cellspacing="0" class="tab3">
                                    <tr v-for="n in 16" v-if="n>10" class="xuline" style="width:16%; float:left;">
                                        <template v-for="y in flo.maxY" class="xuline" style="width:25%; float:left;">
                                            <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta)">
                                                <td v-bind:class="{'cur':flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0}"
                                                    @click="locationEdit(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).id)">
                                                   <span>
												   {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor).name}}
												 
												   </span>
												  <img src="../../static/img/redHomeIcon.png"></img>
												   </td>
                                            </template>
                                            <template v-else-if="$store.getters.sta"  class="cur">
                                                <td class="curfour"></td>
                                            </template>
                                            <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false)">
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 && flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).isCount <= 1&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="cur" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                       <span>
													   {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													   </span>
													    <img src="../../static/img/redHomeIcon.png"></img>
													   </td>
                                                
												</template>
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 && flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).isCount > 1&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="curTwo" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                       <span>
													   {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													   </span>
													    <img src="../../static/img/blueHomeIcon.png"></img>
													   </td>
                                                </template>
                                                <template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 0&&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==0">
                                                    <td class="curThree" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
                                                       <span>
													   {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													   </span>
                                                    </td>
                                                </template>
												<!-- 物料 -->
												<template v-if="flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).state == 1 &&flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).type ==1">
												    <td class="curFive" @click="cusInventory(flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).id,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).whetherPublic,flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name)">
												       <span>
													  {{flo.itemList.find(v=>v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&$store.getters.sta==false).name}}
													  </span>
													  </td>
												</template>
                                            </template>
                                            <template v-else-if="$store.getters.sta==false"  class="cur">
                                                <td class="curfour"></td>
                                            </template>

                                        </template>

                                    </tr>
                                </table>

                            </div>

                            <!-- <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<电脑>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> -->
                            <div class="tongji" v-if="$store.getters.ismobilePhone == false">
                                <!--<div v-for="floside in floSideCount" v-if="flo.floor == floside.floor" :class="'fl_'+floside.side"><span class="red">{{floside.usecount}}</span>/{{floside.flosidecount}}</div>-->
                                <div class="fl_1"><span style="color: #C0C0C0;">{{flo.aInfoa}}</span>/{{flo.aInfob}}</div>
                                <div class="fl_2"><span style="color: #C0C0C0;">{{flo.bInfoa}}</span>/{{flo.bInfob}}</div>
                                <div class="fl_3"><span style="color: #C0C0C0;">{{flo.cInfoa}}</span>/{{flo.cInfob}}</div>
                            </div>
                        </div>
                    </div>


                    <!-- 电脑 -->
                    <div class="table_qh" id="table_qh" v-if="$store.getters.ismobilePhone == false">
                        <ul  >
                            <template v-for="(flo,index) in locationList">
                                <li  :class="{'background cur':changeRed == index}" :id="'tabBtn'+flo.floor"  @click="listCut(flo.floor)" v-if="flo.floor == 0">G/F</li>
                                <li  :class="{'background cur':changeRed == index}" :id="'tabBtn'+flo.floor"  @click="listCut(flo.floor)" v-else-if="flo.floor!=0&&flo.floor!=3">{{flo.floor}}/F</li>

                            </template>
                        </ul>
                    </div>


                    <!-- 手机端主界面 -->
				 <div v-if="$store.getters.ismobilePhone" class="banckFont" >倉庫一覽</div>

				 <div  v-if="$store.getters.ismobilePhone">
					 
					 <div style="margin:12px 0 12px 0;color: #333333; font-size: 14px;">當前{{presentnum}}/F<span style="color: #333333;">樓層共{{locationList[num].floorcount}}個位置，剩餘{{locationList[num].floorcount-locationList[num].usecount}}個 </span></div>
				 <div class="mob_tongjiLeft"><span class="font1">Left</span></br><span class="font2" ><span style="color: #999999;">{{locationList[num].aInfoa}}</span >/{{locationList[num].aInfob}}</span></div>
				 <div class="mob_tongjiMiddle" ><span class="font1">Middle</span></br><span class="font2"><span style="color: #999999;">{{locationList[num].bInfoa}}</span>/{{locationList[num].bInfob}}</span></div>
				 <div class="mob_tongjiRight"><span class="font1">Right</span></br><span class="font2"><span style="color: #999999;">{{locationList[num].cInfoa}}</span>/{{locationList[num].cInfob}}</span></div>
				 <div class="table_qh" id="table_qh" >
				     <ul  >
				         <template v-for="(flo,index) in locationList">
				             <li  :class="{'background cur':changeRed == index}" :id="'tabBtn'+flo.floor"  @click="listCut(flo.floor)" v-if="flo.floor == 0">G/F</li>
				             <li  :class="{'background cur':changeRed == index}" :id="'tabBtn'+flo.floor"  @click="listCut(flo.floor)" v-else-if="flo.floor!=0&&flo.floor!=3">{{flo.floor}}/F</li>
				 
				         </template>
				     </ul>
				 </div>
				 </div> 
			
			
                   <!-- <div class="mob_tongji" v-for="(flo,index) in locationList" v-if="$store.getters.ismobilePhone">
                      
						<div class="fr" v-if="index ==0">總樓層共<span class="bule">{{flo.loccount}}</span>個，總樓層共使用<span class="bule">{{flo.useflocount}}</span>個</div>
                        <div class="fl">當前樓層共<span class="red">{{flo.floorcount}}</span>個位置，已使用<span class="red">{{flo.usecount}}</span>個，<span>剩余{{flo.surolus}}</span>個</div>
                        <div class="mob_tjTxt">
                           <div class="fl_0" v-if="flo.floor == 0">G/F</div>
                            <div class="fl_0" v-else="flo.floor == 0">{{flo.floor}}/F</div>
                            <div class="fl_1"><span style="color: #C0C0C0;">{{flo.aInfoa}}</span>/{{flo.aInfob}}</div>
                            <div class="fl_2"><span style="color: #C0C0C0;">{{flo.bInfoa}}</span>/{{flo.bInfob}}</div>
                            <div class="fl_3"><span style="color: #C0C0C0;">{{flo.cInfoa}}</span>/{{flo.cInfob}}</div>
                        </div>

                    </div> -->
                   
                </div>

            </div>
        </div>



        <!--&lt;!&ndash;編輯頁面&ndash;&gt;-->
        <el-dialog :title="dialogName" :visible.sync="dialogDiscEditVisible" width="400px">
            <el-form  :model="locationForm"  :rules="locationRules"  ref="locationForm" label-width="130px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item label="貨架名:" prop="name">
                            <el-input v-model="locationForm.name" type="text" v-on:blur="itemChange(locationForm.name)" style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="樓層:" prop="floor">
                            <el-select :span="24" style="width:200px" v-model="locationForm.floor"  placeholder="請選擇" >
                                <el-option
                                        v-for="item in floorSelect"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="X軸:" prop="x">
                            <el-input-number v-model="locationForm.x" controls-position="right" style="width:200px"  v-on:input="a" :min="1" :max="16" ></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Y軸:" prop="y">
                            <el-input-number v-model="locationForm.y" controls-position="right" style="width:200px"  v-on:input="b" :min="1" :max="30"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" id="operation">
                <el-button @click="dialogDiscEditVisible = false" >取消</el-button>
                <el-button type="primary"  @click="locationSave" :loading="addEidtloading">確認</el-button>
                <template v-if="locationForm.id != '' && locationForm.state == 0">
                    <el-button style="float: left"  type="primaryTwo" @click="locationDel(locationForm.id)">刪除</el-button>
                </template>
            </div>
        </el-dialog>



        <!-- 庫存 -->
        <el-dialog :visible.sync="tkshow">
            <span>貨架編號：{{shelfName}}</span>
            <div class="ruku_list">
                <div class="listSelect"><!-- class="quanxuan_box" v-if="canIS_DIO" -->
                    <el-select @change="selectChangedType" v-model="selectTypeValue" placeholder="請選擇" clearable>
                        <el-option v-for="item in TypeList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                  <el-select @change="selectChanged" v-model="selectValue" placeholder="請選擇" clearable>
                      <el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                  </el-select>
				 <!--  <el-select v-model="value" placeholder="请选择">
                       <el-option
                         v-for="item in orderTypeList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
                       </el-option>
                     </el-select> -->
				   <!-- <input @change="isAllow" type="checkbox" name="hobbies" id="box01" value="敲代码" v-model="hobbies"> -->
                   <!-- <label for="box01">是否允許多個用戶使用此位置</label> -->
                </div>
                <template v-for="(lnames,i) in locationNames">
                <table cellspacing="0" cellpadding="0" class="responsive">
                        <thead >
                        <tr style="background-color: #6A8FFF; color: #FFFFFF;">
                            <th style="text-align: left" colspan="4">{{lnames}}&nbsp;
                            <el-button type="primary" @click="selDetails(locationCust[i])" >客戶詳情</el-button>
							<span style="float: right;">單：{{i+1}}</span>
							</th>
							
                        </tr>
                        <tr>
                            <th>訂單號</th>
                            <th>單位</th>
                            <th>物品</th>
                            <th style="width: 30%">創建時間</th>
                        </tr>
                        </thead>
                        <tr v-if="locationListB.length != 0" v-for="(item1,index) in locationListB" >
                            
							
							<!--<td class="number" v-if="index == 0">-->
                                <!--{{item1.name}}-->
                            <!--</td>-->
                            <template v-if="item1.cCode == lnames.substr(0,lnames.indexOf('('))">
                                <td class="actions">
                                    {{item1.sCode}}
                                </td>
                                <td class="actions">
                                    {{item1.unit}}({{item1.boxNo}})
                                </td>
                                <td class="actions" >
                                    {{item1.item}}
                                </td>
                                <td class="actions">
                                    {{item1.createDate}}
                                </td>
                            </template>
                        </tr>

                    <tr  v-if="locationListB.length == 0">
                        <td colspan="4">暫無數據</td>
                    </tr>

                </table>
                </template>
            </div>
        </el-dialog>



    </div>
</template>

<script>
    //    function boxheight(){ //函數：獲取尺寸
    //        //獲取流覽器窗口高度
    //        var winHeight=0;
    //        if (window.innerHeight)
    //            winHeight = window.innerHeight;
    //        else if ((document.body) && (document.body.clientHeight))
    //            winHeight = document.body.clientHeight;
    //        //通過Document對body進行檢測，獲取流覽器視覺化高度
    //        if (document.documentElement && document.documentElement.clientHeight)
    //            winHeight = document.documentElement.clientHeight;
    //        //DIV高度為流覽器窗口高度
    //        document.getElementById("table_qh").style.height= winHeight +"px";
    //
    //    }
    //    window.onresize=boxheight; //視窗或框架被調整大小時執行


    import { getLocationList,insertLocation,getLocationById,updateLocation,deleteLocationById,getValidateLocationName,getLocationByXY,getCusInventory,updateLocationWhether} from '../api/api'

    export default {
        components: {},
        methods: {
			selectChangedType(value) {
              var params={whetherPublic:2,id:this.locationId,type:parseInt(value)};
              return updateLocationWhether(params).then(data=>{
                  let {data:res={}}=data;
                  if(res.errcode==200){
                      this.$message.success('設置成功');
                      this.getLocationList();
                  }else{
                      this.$message.error(res.errmsg);
                  }
              });
			  },
            selectChanged(value) {
                console.log(value)
                var params={whetherPublic:parseInt(value),id:this.locationId,type:2};
                return updateLocationWhether(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        this.$message.success('設置成功');
                        this.getLocationList();
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            selDetails(custId){   //查看客戶詳情資訊
                this.$router.push({
                    name: '客戶詳情',
                    params: {
                        id: custId
                    }
                })
                this.tkshow = false;
              /*  var path="/customer/"+row.custId
                this.$router.push(path);*/
            },
            isAllow(){
              //   let status = 0;
              // if(document.getElementById("box01").checked){
              //       status = 1;
              // }
              //   var params={whetherPublic:status,id:this.locationId};
              //   return updateLocationWhether(params).then(data=>{
              //       let {data:res={}}=data;
              //       if(res.errcode==200){
              //           this.$message.success('設置成功');
              //           this.getLocationList();
              //       }else{
              //           this.$message.error(res.errmsg);
              //       }
              //   });

            },
            a(){
                if(this.thx != this.locationForm.x){
                    this.isx = true;
                }else{
                    this.isx = false;
                }
            },
            b(){
                if(this.thy != this.locationForm.y){
                    this.isy = true;
                }else{
                    this.isy = false;
                }

            },
            getLocationList(){              //載入頁面
                this.EDIT_LOCATION = this.$store.getters.hasPermission("EDIT_LOCATION");//查詢是否能修改
//                document.getElementById("table_qh").offsetHeight = 80;
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size};
                return getLocationList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        this.locationList=res.data;
                        // 計算所有的倉庫數量和使用數量
                        let allFloorCount = 0
                        let allUseCount = 0
                        this.locationList.map((item)=>{
                            if(item.floor!=3){
                                allFloorCount += item.floorcount
                                allUseCount += item.usecount
                            }
                        })
                        this.floorcountSum = allFloorCount
                        this.useflocountSum = allUseCount
						 // console.log("111");
						 // console.log(this.locationList);
                        this.floCount=data.data;

                        this.tableloading=false;
                        this.loading =true;
                        this.loadingimg =false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            listCut(index){     //切換樓層效果
                this.changeRed = index;
                this.num=index;
				if(index==0)
					this.presentnum="G";
				else
				this.presentnum=index;
				

            },
            itemChange(value){
                this.locationForm.name = value.toUpperCase();
            },
            locationAdd(){
                this.dialogName="新增貨架",
                    this.dialogDiscEditVisible=true;
                this.resetForm("locationForm");
                this.locationForm={
                    id:"",
                    name:"",
                    floor:"",
                    side:"",
                    x:"",
                    y:""
                }

            },
            cusInventory(id,status,name){           //客戶庫存
               getLocationById(id).then(data=>{
                    let item=data.data;
                    if(item.errcode == 200) {
                        this.selectValue = item.data.whetherPublic+"";
                        this.selectTypeValue= item.data.type+"";
                    }
                });
                if(status == 0){
                    this.hobbies =false;
                }else{
                    this.hobbies = true;
                }
                this.shelfName=name;
                this.locationId = id;
                this.tkshow = true;
                return getCusInventory(id).then(data=> {
                    this.locationNames = [];
                    this.locationCust=[];
                    let {data: res = {}} = data;
                    if (res.errcode == 200) {
                        var obj = res.data;
                        this.locationListB = obj;
//                        this.locationListB.forEach((a)=>{
//
//                        });
                        for(var i =0;i<this.locationListB.length;i++){
                            this.locationListB[i].createDate = new Date(this.locationListB[i].createDate*1000).Format("yyyy-MM-dd hh:mm");
                            if(this.locationNames.indexOf(this.locationListB[i].cCode+'('+this.locationListB[i].name+')') == -1){
                               this.locationNames.push(this.locationListB[i].cCode+'('+this.locationListB[i].name+')');
                            }
                            if(this.locationCust.indexOf(this.locationListB[i].custId) == -1){
                                this.locationCust.push(this.locationListB[i].custId);
                            }
                        }
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            locationDel(id){
                this.$confirm('您確定刪除此資料嗎', '刪除提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteLocationById(id).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            this.$message.success('刪除成功');
                            this.getLocationList();
                            this.dialogDiscEditVisible=false;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刪除'
                    });
                });
            },
            locationEdit(id){
                if(this.EDIT_LOCATION === true){
                    this.dialogName="編輯架子",
                        this.dialogDiscEditVisible=true;
                    this.resetForm("locationForm");
                    this.locationById(id);
                }
            },
            locationById(id){
                return getLocationById(id).then(data=>{
                    let item=data.data;
                    if(item.errcode == 200){
                        this.thx = item.data.x;
                        this.thy = item.data.y;
                        Object.assign(this.locationForm,item.data);
                    }else{
                        this.$message.error(item.errmsg);
                    }


                });
            },
			clickprinting()
			{
				console.log("打印報表");
				this.$router.push({
				    name: '打印報表'
				})
			},
            locationSave(){
                this.$refs.locationForm.validate((valid) => {
                    if (valid) {

                        if(parseInt(this.locationForm.x)>0 && parseInt(this.locationForm.x)<5){
                            this.locationForm.side = 1;
                        }
                        if(parseInt(this.locationForm.x)>4 && parseInt(this.locationForm.x)<13){
                            this.locationForm.side = 2;
                        }
                        if(parseInt(this.locationForm.x)>12 && parseInt(this.locationForm.x)<17){
                            this.locationForm.side = 3;
                        }


                        if(this.locationForm.id==""){       //新增
                            //驗證位置是否使用
                            var params={floor:this.locationForm.floor,x:this.locationForm.x,y:this.locationForm.y};
                            getLocationByXY(params).then(data=>{
                                let item=data.data;
                                if(item.data == false){
                                    return this.$message.error("該位置已被使用！");
                                }else{
                                    this.addEidtloading=true;
                                    //var  params=Object.assign({},this.locationForm);
                                    var  params={name:this.locationForm.name,side:this.locationForm.side,floor:this.locationForm.floor,x:this.locationForm.x,y:this.locationForm.y,side:this.locationForm.side};
                                    insertLocation(params).then(data=>{
                                        let {data:res={}}=data;
                                        this.addEidtloading=false;
                                        //let {errcode,errmsg}=data;
                                        if(res.errcode==200){
                                            this.$message.success("新增成功！！");
                                            this.getLocationList();
                                            this.resetForm("locationForm");
                                            this.dialogDiscEditVisible=false;
                                        }else{
                                            this.$message.error(res.errmsg);
                                        }
                                    },err=>{
                                        this.addEidtloading=false;
                                    });

                                }
                            });

                        }else{                          //編輯
//                            console.log(this.isx);
                            if(this.isx == true || this.isy == true){
                                //驗證位置是否使用
                                var params={floor:this.locationForm.floor,x:this.locationForm.x,y:this.locationForm.y};
                                getLocationByXY(params).then(data=> {
                                    let item = data.data;
                                    if (item.data == false) {
                                        return this.$message.error("該位置已被使用！");
                                    } else {
                                        var params = {
                                            id: this.locationForm.id,
                                            name: this.locationForm.name,
                                            side: this.locationForm.side,
                                            floor: this.locationForm.floor,
                                            x: this.locationForm.x,
                                            y: this.locationForm.y,
                                            side: this.locationForm.side
                                        };
                                        updateLocation(params).then(data => {
                                            this.addEidtloading = false;
                                            let {data: res = {}} = data;
                                            if (res.errcode == 200) {
                                                this.$message.success("修改成功");
                                                this.getLocationList();
                                                this.resetForm("locationForm");
                                                this.dialogDiscEditVisible = false;
                                            } else {
                                                this.$message.error(res.errmsg);
                                            }
                                        }, err => {
                                            this.addEidtloading = false;
                                        });
                                    }
                                });
                            }else{
                                var params = {
                                    id: this.locationForm.id,
                                    name: this.locationForm.name,
                                    side: this.locationForm.side,
                                    floor: this.locationForm.floor,
                                    x: this.locationForm.x,
                                    y: this.locationForm.y,
                                    side: this.locationForm.side
                                };
                                updateLocation(params).then(data => {
                                    this.addEidtloading = false;
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success("修改成功");
                                        this.getLocationList();
                                        this.resetForm("locationForm");
                                        this.dialogDiscEditVisible = false;
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                }, err => {
                                    this.addEidtloading = false;
                                });
                            }

                        }


                    }
                });
            },
            //清除表單內容
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        data() {
            var validateNumber=(rule, value, callback) => {
                var reg=/^[1-15]\d*$/;
                if (value!=""&&value!=null){
                    if(!reg.test(value)){
                        callback(new Error(this.$t('m.canOnlyEnterPositiveNumber')));
                    }
                }
                callback();
            };
            //驗證客戶編號是否重複
            var validateLocationName=(rule, value, callback) => {
                if(this.locationForm.id == ''){
                    var params={name:this.locationForm.name};
                    return getValidateLocationName(params).then(data=>{
                        let item=data.data.data;
                        if(item){
                            callback(new Error('貨架名重複！'));
                        }else {
                            callback();
                        }
                    });
                }
                callback();
            };

                return {
                locationNames:[],
                locationCust:[],
                locationId:0,
                hobbies:false,
                loading: false,
                loadingimg: true,
                custName:'',
                tkshow:false,
                isx:false,
                isy:false,
                thx:0,
                thy:0,
                    shelfName:'',
                EDIT_LOCATION:false,//是否可以修改
                num:0,
				presentnum:'G',//当前楼层
                changeRed:0,
                hjis:false,
                //查詢準則
                searchBankName:"",
                storList:[],
                locationList:[],
                locationListA:[],
                locationListB:[],
                floCount:[],
                floSideCount:[],
                selectionItems:[],
                tableloading:false,
                addEidtloading:false,
                dialogDiscEditVisible:false,
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                dialogName:'',
                locationForm:{
                    id:"",
                    name:"",
                    floor:"",
                    side:"",
                    order:""
                },
				orderTypeList: [{
                  value: '0',
                  label: '一單'
                }, {
                  value: '1',
                  label: '多單'
                }],
                selectValue:'0',
                selectTypeValue:'0',
                TypeList: [{
                    value: '0',
                    label: '正常單'
                },  {
                    value: '1',
                    label: '物料單'
                }],
                options: [{
                    value: '1',
                    label: '左'
                }, {
                    value: '2',
                    label: '中'
                }, {
                    value: '3',
                    label: '右'
                }],
                floorSelect: [{
                    value: '0',
                    label: 'G/F'
                }, {
                    value: '1',
                    label: '1/F'
                }, {
                    value: '2',
                    label: '2/F'
                }],
                //新增客戶資訊表單驗證
                locationRules: {
                    name: [
                        {required: true, message: '貨架名不能為空', trigger: 'blur' },
                        {max:10,message:"貨架名最多只能10位",trigger:'blur'},
                        { validator: validateLocationName,trigger: 'blur' }
                    ],
                    floor: [
                        {required: true, message: '請選擇樓層', trigger: 'blur' }
                    ],
                    x: [
                        {required: true, message: 'x軸不能為空', trigger: 'blur' },
                    ],
                    y: [
                        {required: true, message: 'y軸不能為空', trigger: 'blur' },
                    ],
                },
                // 所有倉庫數量
                floorcountSum: 0,
                // 倉庫所有使用數量
                useflocountSum: 0
            }
        },
		
        activated(){
//            document.write('屏幕宽度：' + screen.availWidth);
//            document.write('屏幕高度：' + screen.availHeight);
            if(screen.availWidth == 1024){
                this.$store.commit("setCollapsed",true);
            }
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小時
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            };
            this.getLocationList();
//            if(this.$store.getters.isLoding == true){
//                location.reload();
//            }
        },
        computed: {
            canIS_DIO(){
                return this.$store.getters.hasPermission("IS_DIO");
            }

        }

    }

</script>

<style lang="scss" scoped>
	.mob_tongjiLeft
	{
		background-color: #FFE7E7;
		float: left; 
		width: 29%;
		height: 300px;
		text-align: center;
		
	}
	.mob_tongjiLeft .font1
	{
		display:block;
		margin-top: 30px;
		font-size:18px;
		color: #FFA4A4;
		font-family:PingFangSC-Semibold,PingFang SC;
		
	}
	.font2
	{
		display:block;
		margin-top: 70px;
		font-size:18px;
		font-weight: bold;
		color: #333333;
	}
	.mob_tongjiMiddle
	{
		background-color: #EBF1FF;
		 float:left;
		 width:38%;
		height: 300px;
		margin-left: 5px;
		text-align: center;
	}
	.mob_tongjiMiddle .font1
	{
		display:block;
		margin-top: 30px;
		font-size:18px;
		color: #A4C5FC;
		font-family:PingFangSC-Semibold,PingFang SC;
	}
	.mob_tongjiRight
	{
		background-color: #F0E9FF;
		float:right;
		width: 29.7%;
		height: 300px;
		margin-left: 5px;
		text-align: center;
	}
	.mob_tongjiRight .font1
	{
		display:block;
		margin-top: 30px;
		font-size:18px;
		color: #E9A4FC;
		font-family:PingFangSC-Semibold,PingFang SC;
	}
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .abc {
        background: red;
    }
	.listSelect
	{
		margin-top: 10px;
		margin-bottom: 10px;
	}
    .xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
    .xinz button:hover{background:#4B78FF;color:#fff;}

    ul,li{padding-left:0px;margin: 0px;}

    .background{
        background: #4B78FF;
    }
</style>




// WEBPACK FOOTER //
// src/views/Homepage.vue